// 只用一次不迁移
export const ProductElementFore = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" fill="none" viewBox="0 0 41 41" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_925_3440)">
      <path
        d="M18.3531 13.8679L18.1699 11.0063C18.0522 9.1691 16.4675 7.77512 14.6304 7.89275L4.7816 8.52334C2.94441 8.64097 1.55044 10.2257 1.66807 12.0628L2.82693 30.1625C2.94456 31.9997 4.52926 33.3937 6.36645 33.276L16.2405 32.6438C18.0678 32.5268 19.4586 30.9578 19.3555 29.1297L19.0333 23.4131"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2.5"
      />
      <path
        d="M22.6101 14.3811L22.8262 11.0063C22.9439 9.1691 24.5286 7.77512 26.3657 7.89275L36.2145 8.52334C38.0517 8.64097 39.4457 10.2257 39.328 12.0628L38.1692 30.1625C38.0515 31.9997 36.4668 33.3937 34.6296 33.276L24.7809 32.6455C22.9437 32.5278 21.5497 30.9431 21.6674 29.1059L22.0323 23.4068"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="2.5"
      />
      <path
        d="M29.3125 22.3977C27.4878 19.2372 24.14 17.5418 20.8803 17.7928C19.7003 17.8837 18.5318 18.2297 17.4513 18.8535C15.9816 19.702 14.8758 20.9485 14.1803 22.3977"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
      <path
        d="M24.598 22.2326L29.3121 22.3977L29.9102 17.4336"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      />
    </g>
    <defs>
      <clipPath id="clip0_925_3440">
        <rect height="40" width="40" fill="currentColor" transform="translate(0.5 0.580078)" />
      </clipPath>
    </defs>
  </svg>
);
